import React from "react";
import img1 from "../../Assets/About/img1.jpeg";
import img2 from "../../Assets/About/img2.jpeg";
import img3 from "../../Assets/About/img3.jpeg";
import img4 from "../../Assets/About/img4.jpeg";
const TestLaboratory = () => {
  return (
    <React.Fragment>
      <div className="text-center mt-10 space-y-5">
        {/* <h1 className="text-3xl lg:text-5xl font-semibold text-center mb-4" data-aos="flip-up">About <span className='text-[#0218DC]'>Test Laboratory</span></h1> */}
        <p
          className="text-gray-600 text-base md:text-md lg:text-xl mb-12 max-w-[70%] mx-auto"
          data-aos="flip-down"
        >
          Established in 2018 Bhubaneswar ,(Odisha) named “OTL Consultancy
          Service Private Limited” an ISO 9001: 2008 Certified company, and also
          NABL accredited Laboratory, based on ISO/IES 17025 -2017 . We are
          providing various kind of Civil Engineering services, including
          Designing, Drawing, Estimate Preparation DPR, All types of material
          testing SubSoil, Exploration, NDT, PLT, PIT, planning building & water
          test both physically and chemically, bridges and architecture
          designing .These are offered as per the requirement of customers.{" "}
        </p>
        <p className="text-[#0218DC] text-base md:text-md lg:text-xl">
          The activities of the company are being managed by Board of Directors.{" "}
        </p>
        <p
          className="text-gray-600 text-base md:text-md lg:text-xl mb-12 max-w-[90%] mx-auto"
          data-aos="zoom-in"
        >
          {/* Established in 2018 Bhubaneswar ,(Odisha) named “ OTL Consultancy Service ” an ISO 9001: 2008 Certified company, and also NABL accredited Laboratory, based on ISO/IES 17025 -2017 . */}
          {/* We are providing various kind of Civil Engineering, services include Material Testing ,SubSoil Investigation, Engineering Survey, Design ,Drawing, DPR & Estimate .These are offered as per the requirement of customers. */}
          The activities of the company are being managed by Board of Directors.
          Our team of experts and professional Engineers are gaining Experience
          from past many years in the field of civil engineering. Further our
          team managed and guided by our Expert Mr. S P Sethi who has achieved
          excellent exposure in civil engineering services by providing complete
          Customers satisfaction. We have 17 no employees including Tech
          Manager, Material Engineer, Designer, Estimator, Surveyor, Road
          Designer and Marketing Representative. We use latest and high accuracy
          machinery and equipment in our services. We provide these services in
          various part of the country and make a permanent relationship with our
          esteemed clients.
        </p>
        <h1
          className="text-3xl lg:text-5xl font-semibold text-center mb-4 underline decoration-red-500"
          data-aos="flip-up"
        >
          Aim <span className="text-[#0218DC]">of Lab</span>
        </h1>
        <p
          className="text-gray-600 text-base md:text-md lg:text-xl mb-12 max-w-[90%] mx-auto"
          data-aos="flip-down"
        >
          The Aim of OTLCS is to provide scientific, systematic, facilities &
          DPR, and dependable material testing facilities to meet the customer
          requirements.{" "}
        </p>
        <h1
          className="text-3xl lg:text-5xl font-semibold text-center mb-4  underline decoration-red-500"
          data-aos="flip-up"
        >
          Quality<span className="text-[#0218DC]"> Policy </span>
        </h1>
        <p
          className="text-gray-600 text-base md:text-md lg:text-xl mb-12 max-w-[90%] mx-auto"
          data-aos="zoom-in"
        >
          OTL Consultancy Service Private Limited is committed to provide
          Quality Technical Consultancy Services to the best satisfaction of
          customers
          {/* OTLCS is committed to ensure competency, impartiality, integrity and consistent operations of laboratory activities as well as to maintain confidentiality, good professional practice and build high level of confidence in our valued customers as per requirements ISO/IES 17025: 2017 and accreditation body through the involvement of all personnel. The Laboratory standard of service is to ensure that it does not engage in any activities that would diminish confidence in its competence, impartiality, judgment, operational integrity with consistent operation and shall never be compromised */}
        </p>
        <h1
          className="text-3xl lg:text-5xl font-semibold text-center mb-4  underline decoration-red-500"
          data-aos="flip-up"
        >
          Quality<span className="text-[#0218DC]"> Objectives</span>
        </h1>
        <p
          className="text-gray-600 text-base md:text-md lg:text-xl mb-12 max-w-[90%] mx-auto"
          data-aos="zoom-in"
        >
          OTL Consultancy Service Private Limited is committed to ensure
          competency, impartiality, integrity and consistent operations of
          laboratory activities as well as to maintain confidentiality, good
          professional practice and build high level of confidence in our valued
          customers as per requirements ISO/IES 17025: 2017 and accreditation
          body through the involvement of all personnel. The Laboratory standard
          of service is to ensure that it does not engage in any activities that
          would diminish confidence in its competence, impartiality, judgment,
          operational integrity with consistent operation and shall never be
          compromised
        </p>
      </div>
      <div className="mt-8 px-4 md:px-16 flex flex-col items-center lg:flex-row space-y-6 md:space-y-0 md:space-x-10">
        <div className="w-full lg:w-[50%]" data-aos="zoom-in-down">
          <div className="flex flex-col md:flex-row justify-center gap-3">
            <div className="w-full md:w-[50%] space-y-3">
              <img
                className="w-full sm:rounded-tl-lg"
                src={img1}
                alt="Trophy"
              />
              <img className="w-full rounded-bl-lg" src={img2} alt="Trophy" />
            </div>
            <div className="w-full md:w-[50%] space-y-3">
              <img
                className="w-full sm:rounded-tr-lg"
                src={img3}
                alt="Trophy"
              />
              <img src={img4} className="w-full sm:rounded-br-lg" alt="img" />
            </div>
          </div>
        </div>
        <div className="w-full lg:w-[50%] space-y-10" data-aos="zoom-in-left">
          <h1 className="text-3xl lg:text-5xl font-semibold">
            We’ll Ensure You Always Get Best Results
          </h1>

          <p className="text-gray-600 text-base md:text-md lg:text-xl">
            Established in 2018 Bhubaneswar ,(Odisha) named “OTL Consultancy
            Service ” an ISO 9001: 2008 Certified company, and also NABL
            accredited Laboratory, based on ISO/IES 17025 -2017 . We are
            providing various kind of Civil Engineering, services include
            Material Testing ,Sub- Soil Investigation, Engineering Survey,
            Design ,Drawing, DPR & Estimate .These are offered as per the
            requirement of customers.
          </p>
          {/* <button className='bg-[#1C29A0] text-white px-5 py-3 rounded-md'>Know More</button> */}
          <button className="tracking-wide bg-[#1522ED] text-white font-bold py-3 px-4 rounded">
            Know More
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TestLaboratory;
